import { IFilterFichaSsoModel } from "../interfaces/ficha-sso/IFilterFichaSsoModel";

export class FilterFichaSsoModel implements IFilterFichaSsoModel{
    sedes: number[];
    anio: number;
    meses: string[];
    contratista: string;
    idEstado: number;
    page: number;
    pageSize: number;
    idCompania: number;
    
    constructor(){
        this.sedes = [];
        this.anio= new Date().getFullYear();
        this.meses = [];
        this.contratista = '';
        this.idEstado = 0;
        this.page = 1;
        this.pageSize = 30;
        this.idCompania = 0;
    }
}